<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="submit">
      <dt-modal v-model="isVisible">
        <div slot="header">
          <h4 class="modal-title">
            Address
          </h4>
        </div>
        <div slot="body">
          <contact-summary
            class="mb-4"
            :contact="value"
          />
          <div class="form-control custom-form">
            <dt-select
              v-model="addressType"
              label="Address Type"
              name="addressType"
              :options="lookups['AddressType']"
              validate="required"
            />
            <dt-input
              v-model="addressLines"
              name="AddressLines"
              label="Street Address"
              validate="required"
            />
            <dt-input
              v-model="city"
              name="City"
              label="City"
              validate="required"
            />
            <dt-select
              v-model="stateProvince"
              label="State"
              name="stateProvince"
              :options="lookups['StateProvince']"
              validate="required"
            />
            <dt-input
              v-model="postalCode"
              name="PostalCode"
              label="Postal Code"
              validate="required"
            />
            <dt-select
              v-model="country"
              label="Country"
              name="country"
              :options="lookups['Country']"
              validate="required"
            />
            <dt-textarea
              v-model="addressNote"
              name="AddressNote"
              label="Notes"
            />
          </div>
        </div>
        <div slot="footer">
          <button
            type="button"
            class="btn btn-light"
            @click="close()"
          >Cancel</button>
          <button
            type="submit"
            class="btn btn-primary"
            @click="save()"
          >Save</button>
        </div>
      </dt-modal>
    </form>
  </ValidationObserver>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import DtModal from '@/components/utilities/modal/dt-modal.vue'
import DtInput from '@/components/utilities/form/dt-input'
import DtSelect from '@/components/utilities/form/dt-select'
import DtTextarea from '@/components/utilities/form/dt-textarea'
import ContactSummary from '@/components/contacts/forms/contact-summary'
export default {
  name: 'contact-address',
  components: {
    DtModal,
    DtInput,
    DtSelect,
    DtTextarea,
    ContactSummary
  },
  props: {
    value: {
      type: Object
    },
    address: {
      type: Object,
      default() {
        return {
          firm: 0,
          contact: 0,
          contactAddress: 0,
          address: 0,
          addressType: 0,
          addressLines: '',
          city: '',
          stateProvince: 0,
          postalCode: '',
          country: 0,
          addressNote: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters('lookups', ['lookups']),
    addressType: {
      get() {
        return this.address !== null ? this.address.addressType : 0
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'addressType',
          value: parseInt(value)
        })
      }
    },
    addressLines: {
      get() {
        return this.address !== null ? this.address.addressLines : ''
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'addressLines',
          value: value
        })
      }
    },
    city: {
      get() {
        return this.address !== null ? this.address.city : ''
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'city',
          value: value
        })
      }
    },
    stateProvince: {
      get() {
        return this.address !== null ? this.address.stateProvince : 0
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'stateProvince',
          value: parseInt(value)
        })
      }
    },
    postalCode: {
      get() {
        return this.address !== null ? this.address.postalCode : ''
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'postalCode',
          value: value
        })
      }
    },
    country: {
      get() {
        return this.address !== null ? this.address.country : 0
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'country',
          value: parseInt(value)
        })
      }
    },
    addressNote: {
      get() {
        return this.address !== null ? this.address.addressNote : ''
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'addressNote',
          value: value
        })
      }
    },
    isVisible: {
      get() {
        return this.value !== null
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    ...mapActions('contacts', ['setItem', 'removeAddress']),
    close() {
      if (this.address.contactAddress === -1) {
        this.removeAddress(-1)
      }
      this.$emit('closing')
    },
    async save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.$emit('send', this.address.contactAddress)
        }
      })
    },
    submit() {}
  }
}
</script>
<style lang="scss" scoped>
.custom-form {
  text-align: left;
  max-height: 450px;
  height: 450px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/forms/address.vue